import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Table from "react-bootstrap/Table";
import "./style_secondary.css";

const LegendCompartments = ({
  highlightNodesByCompound,
  removeAllHighlights,
  compounds,
}) => {
  const [showLegend, setShowLegened] = useState(false);

  const onClick = () => {
    setShowLegened(!showLegend);
  };

  return !!compounds && showLegend ? (
    <div style={styleOpen}>
      <div style={{ maxHeight: "10rem", overflow: "scroll" }}>
        <Table>
          <thead>
            <tr
              style={{
                position: "sticky",
                top: 0,
                zIndex: 1,
                backgroundColor: "white",
              }}
            >
              <th>Sub. Cell. Location</th>
              <th>Color</th>
            </tr>
          </thead>
          <tbody>
            {Object.keys(compounds)
              .sort()
              .map((loc) => {
                return (
                  <tr
                    onMouseOver={() => highlightNodesByCompound(loc)}
                    key={loc}
                    onMouseOut={removeAllHighlights}
                    className={"legendEntry"}
                  >
                    <td>{`${loc[0].toUpperCase()}${loc.slice(1)}`}</td>
                    <td>
                      <FontAwesomeIcon
                        icon="circle"
                        color={compounds[loc]}
                        size="1x"
                      />
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </Table>
      </div>
      <div style={{ display: "grid" }} title={"Close legend"}>
        <FontAwesomeIcon
          onClick={onClick}
          icon="fa-solid fa-square-arrow-up-right"
          size="xl"
          style={styleArrowOpen}
          rotation={90}
          className={"arrowToOpen"}
        />
      </div>
    </div>
  ) : (
    <FontAwesomeIcon
      onClick={onClick}
      icon="fa-solid fa-square-arrow-up-right"
      size="xl"
      style={styleArrowClose}
      rotation={270}
      className={"arrowToOpen"}
      title={"Open legend"}
    />
  );
};

export default LegendCompartments;

const styleOpen = {
  placeSelf: "center end",
  gridRow: "2 / 3",
  gridColumn: "1 / 2",
  backgroundColor: "rgba(255, 255, 255, 0.8)",
  zIndex: 10,
  marginRight: "5px",
  position: "absolute",
  // lineHeight: "1.5rem",
  bottom: "5px",
  paddingLeft: "5px",
  paddingTop: "5px",

  border: "1px solid lightgray",
};

const styleArrowClose = {
  placeSelf: "center end",
  gridRow: "2 / 3",
  gridColumn: "1 / 2",
  zIndex: 10,
  marginRight: "5px",
  padding: "3px",
};

const styleArrowOpen = {
  zIndex: 10,
  padding: "3px",
  boxSizing: "border-box",
  placeSelf: "center end",
};
